import React from 'react';
import * as Opt from '../editor/Helpers';
import MediaSelector from '../editor/fields/MediaSelector';
import TextEditor from '../editor/fields/TextEditor';
import ColorSelector from '../editor/fields/ColorSelector';

class PricingSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }
  render() {
    return (
      <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50 flex' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'} p-0 bg-${this.props.backgroundColor} `}>
        <div className={`container`}>
            <div className='w-full flex justify-center flex-wrap'>
            {/* grab the first two only */}
              {this.props.options.slice(0,2).map((option, index) => (
                <div className={`w-full lg:w-[calc(50%-20px)] ${index === 0 ? 'mb-[30px] lg:mb-0 lg:mr-[20px] mr-0' : ''} ${option.borderWeight} border-${option.borderColor} bg-${option.backgroundColor} rounded-[20px] p-[30px]`} key={index}> 
                  <p className={`fs-5 font-bold mb-[5px] ${option.headerColor}`}>{option.header}</p>
                  <p className={`fs-6 ${option.bodyColor}`}>{option.body}</p>
                  <div className={`border border-${option.lineColor}`}></div>
                  <div className={`block quill-text my-[30px] ${index === 0 ? '' : 'text-white-50'}`} dangerouslySetInnerHTML={{ __html: option.price }}></div>

                  {/* button here */}
                  {(!Window.user_data.isLogged || (Window.user_data.isLogged && !option.hideButtonIfLogged)) && <a href={option.href} className={`n-btn ${option.buttonSize} text-center ${option.buttonStyle} ${option.buttonOptions} block w-full`} style={{ minWidth: "300px" }}>
                    {option.text}
                    <span>{option.iconAfter && <img className={`ml-[5px] ${option.iconColor}`} style={{ width: "18px", height: "18px" }} src={option.iconAfter} />}</span>
                  </a>}
                  <div className={`border border-${option.lineColor} my-[30px]`}></div>

                  {/* List here */}
                  {option.list && option.list.map((list, listIndex) => (
                    <div className='flex items-start mb-[20px]' key={listIndex}>
                      <img src={`${Window.static_path}img/icons/tickIconPriceSection.svg`} height="14px" className={`mr-[10px] mt-[5px] ${list.tickColor}`} alt="tickList" />
                      <div className={`block quill-text ${index === 0 ? '' : 'text-white-50'}`} dangerouslySetInnerHTML={{ __html: list.content }}></div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
      </div>
    );
  };
}

PricingSection.defaultProps = {
  visibility: "",
  backgroundColor: 'white-50',
  options: [
    {
      backgroundColor:'neutral-cloud-500',
      borderWeight: 'border-0',
      borderColor:'neutral-charcoal',
      header: 'Standard',
      headerColor:'neutral-charcoal',
      body: 'Detta får du med vårt Standard paket.',
      bodyColor:'neutral-charcoal',
      price: '0 kr/år',
      text: "Action",
      href: "/",
      buttonSize: "",
      buttonStyle: "btn-outline",
      buttonOptions: "btn-charcoal",
      hideButtonIfLogged: false,
      iconAfter: null,
      iconColor: "neutral-charcoal-filter",
      lineColor: 'neutral-charcoal-300',
      list: [
        {
          tickColor: 'neutral-charcoal-filter',
          content: 'Sälja virke och biobränsle',
        },
        {
          tickColor: 'neutral-charcoal-filter',
          content: 'Begränsad Prisjämförelse',
        },
        {
          tickColor: 'neutral-charcoal-filter',
          content: 'Skogsbruksplan med begränsad information (8 fastigheter)',
        },
      ],
    },
    {
      backgroundColor:'neutral-charcoal-500',
      borderWeight: 'border-0',
      borderColor:'neutral-charcoal',
      header: 'Plus',
      headerColor:'primary-core',
      body: 'Detta får du med vårt Standard paket.',
      bodyColor:'white',
      price: '699 kr/år',
      text: "Action",
      href: "/",
      buttonSize: "",
      buttonStyle: "",
      buttonOptions: "btn-core",
      iconAfter: null,
      iconColor: "white-filter",
      lineColor: 'white-50',
      list: [
        {
          tickColor: 'primary-core-filter',
          content: 'Sälja virke och biobränsle',
        },
        {
          tickColor: 'primary-core-filter',
          content: 'Begränsad Prisjämförelse',
        },
        {
          tickColor: 'primary-core-filter',
          content: 'Skogsbruksplan med begränsad information (8 fastigheter)',
        },
      ],
    },
  ],
}

PricingSection.fields = {
  backgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  visibility: {
    type: "select",
    options: Opt.visibilityOptions
  },
  options: {
    type: "array",
    arrayFields: {
      backgroundColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
      },
      borderWeight: {
        type: 'select',
        options: Opt.border
      },
      borderColor: {
        type: "select",
        options: Opt.colorVariables
      },
      header: { type: "text" },
      headerColor: {
        type: "select",
        options: Opt.colorVariables
      },
      body: { type: "text" },
      bodyColor: {
        type: "select",
        options: Opt.colorVariables
      },
      price: {
        type: "custom",
        render: ({ name, onChange, value }) => <TextEditor name={name} value={value} onChange={onChange} />,
      },
      text: { type: "text" },
      href: { type: "text" },
      buttonSize: {
        type: "select",
        options: Opt.buttonSize
      },
      buttonStyle: {
        type: "select",
        options: Opt.buttonStyle
      },
      buttonOptions: {
        type: "select",
        options: Opt.buttonOptions
      },
      hideButtonIfLogged: {
        type: "radio",
        options: [{label: "Yes", value: true}, {label: "No", value: false}]
      },
      iconAfter: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={name} type={'icon'} onChange={onChange} value={value} />,
      },
      iconColor: {
        type: "select",
        options: Opt.filterOptions
      },
      lineColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
      },
      list: {
          type: "array",
          arrayFields: {
            tickColor: {
              type: "select",
              options: Opt.filterOptions
            },
            content: {
              type: "custom",
              render: ({ name, onChange, value }) => <TextEditor name={name} value={value} onChange={onChange} />,
            },
          },
      },
      
    },
    
    defaultOptionProps: PricingSection.defaultProps.options[0] || {},
    defaultListProps: PricingSection.defaultProps.options[0]?.list[0] || {},
  },

}

export default PricingSection;